import React from 'react';

import * as S from './styles';

import { SelectProps } from '@useblu/ocean-react/Select/types';

interface IChildProps {
  children: React.ReactNode;
}

type ICol =
  | boolean
  | 'auto'
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '10'
  | '11'
  | '12';

interface IChildCol extends IChildProps {
  md?: ICol;
  sm?: ICol;
}

export const FormLabel: React.FC<IChildProps> = ({ children }) => {
  return <S.CustomLabel>{children}</S.CustomLabel>;
};

export const FormRow: React.FC<IChildProps> = ({ children }) => {
  return <S.CustomRow>{children}</S.CustomRow>;
};

export const FormColumn: React.FC<IChildCol> = ({ md, sm, children }) => {
  return (
    <S.CustomCol md={md} sm={sm}>
      {children}
    </S.CustomCol>
  );
};

export const FormSelection: React.FC<
  SelectProps & { $extended?: boolean }
> = props => {
  return <S.CustomSelect {...props} />;
};
